// AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import Loading from "./pages/Loading"; 
import axios from "axios"; 
// Create the context
export const AuthContext = createContext();

// Create the provider component
export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loggingOut, setLoggingOut ] = useState(false); 

  // Mock login function (you can replace it with actual API calls)
  const login = (userData) => {
	 console.log("checking user data in the login function"); 
	 console.log("user data is loged in"); 
	 console.log(userData); 
    setUser(userData);
	 localStorage.setItem("emailaddress", userData.emailaddress); 
    setIsAuthenticated(true);
  };

  // Mock logout function
  const logout = () => {
    setUser(null);
	 localStorage.removeItem("emailaddress"); 
	 axios.get("http://localhost:5000/api/logout").
	 then((response)=>{
		setIsAuthenticated(false);
	 	 setLoggingOut(true); 
  }).catch((error)=>{
		console.log("failed to log out user"); 
		console.log(error); 
	 }
	 ); 
}
if(loggingOut){
  return <Loading message = {"logging out .."} />
}
      // Load auth state from local storage if token exists
  // recheck this method maybe for persistence related 
  useEffect(() => {
    const emailaddress = localStorage.getItem('emailaddress');
	 console.log("page refreshes"); 
	 console.log(emailaddress); 
    if (emailaddress) {
		console.log("user email is found"); 
      setIsAuthenticated(true);
		console.log(isAuthenticated); 
	 }
  });
   return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

